export const BASE_URL = 'http://magento2.inchoo4u.net/';
export const SERVER_URL = BASE_URL + 'rest/all/V1/';
export const PAGE_SIZE = 12;



// WEBPACK FOOTER //
// ./src/constants/serverConfig.js